/* @flow */
import type { Action, PlaybackStatus, SimplifiedTrack } from 'types/index';

const togglePlayerQueueVisibility = (): Action => {
  return { type: 'TOGGLE_PLAYER_QUEUE_VISIBILITY' };
};

const setCurrentTrack = (currentTrackIndex: number, currentTrackId: number): Action => {
  return {
    type: 'SET_CURRENT_TRACK',
    payload: { currentTrackIndex, currentTrackId },
  };
};

const setPlaybackStatus = (playbackStatus: PlaybackStatus): Action => {
  return { type: 'SET_PLAYBACK_STATUS', payload: playbackStatus };
};

const playTracks = (tracks: SimplifiedTrack[]): Action => {
  return { type: 'PLAY_TRACKS', payload: tracks };
};

const clearTracks = (): Action => {
  return { type: 'CLEAR_TRACKS' };
};

export default {
  togglePlayerQueueVisibility,
  setCurrentTrack,
  setPlaybackStatus,
  playTracks,
  clearTracks,
};
